import React from "react";
import { ShieldCheck } from "lucide-react";
import { EVIDENCE_MESSAGE } from "@/lib/risk";

export const EvidenceBanner = () => (
  <div className="flex items-start gap-3 rounded-xl border border-primary/20 bg-primary/[0.03] p-4" data-testid="evidence-banner">
    <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
    <p className="text-sm leading-relaxed text-muted-foreground">{EVIDENCE_MESSAGE}</p>
  </div>
);
